// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";
import {setURLParams} from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    createDraft: `/shipment/draft/create`,
    cancelDraft: "/shipment/draft/cancel",
    getDraftDetail: `/shipment/draft/detail`,
    //
    getShipment: "/shipment/search",
    getShipmentDetail: "/shipment/detail",
    getShipmentDetailByTracking: "/shipment/detail/get_by_tracking_no",
    getShipmentOperateHistory: `/shipment/get_operate_history`,
    //
    getRate: `/shipment/get_rates`,
    getInsuranceRate: "/shipment/insurance/rate",
    //
    buyLabel: "/shipment/pay",
    voidLabel: "/shipment/void_label",
    downloadLabel: "/shipment/download_label",
    //
    checkCanPrint: `/shipment/can_print_label`,
    //
    labelPreview: "/shipment/preview_label",
    qrcodePreview: "/shipment/preview_qr_or_barcode",
    //
    createShareLink: "/shipment/create_share_link",
    previewShareLink: "/shipment/preview_share_link",
    //
    initExportShipment: `/shipment/export`,
    initExportShipmentBillingDetail: `/web/bill/export`
};

// ----------------------------------------------------------------------

const getShipmentDetail = (id) => axios.get(API_ENDPOINTS.getShipmentDetail, {
    params: {
        shipment_no: id
    }
});

const getShipmentDetailByTracking = (number) => axios.get(API_ENDPOINTS.getShipmentDetailByTracking, {
    params: {
        tracking_no: number
    }
});

const getShipmentOperateHistory = (id) => axios.get(API_ENDPOINTS.getShipmentOperateHistory, {
    params: {
        shipment_no: id
    }
});

const getRate = (request) => axios.post(API_ENDPOINTS.getRate, {...request});

const getInsuranceRate = (request) => (signal) => axios.get(API_ENDPOINTS.getInsuranceRate, {
    params: {
        ...request
    },
    signal // 传递 AbortSignal
});

const buyLabel = (request, fingerprint) => axios.post(API_ENDPOINTS.buyLabel, {...request}, {
    headers: {
        "X-Fingerprint-Request-Id": fingerprint?.event_id ?? ""
    }
});

const voidLabel = (id) => axios.get(API_ENDPOINTS.voidLabel, {
    params: {
        shipment_no: id
    }
});

const downloadLabel = (request) => axios.post(API_ENDPOINTS.downloadLabel, {...request}, {responseType: "blob"});

const checkCanPrint = () => axios.get(API_ENDPOINTS.checkCanPrint);

const previewLabel = (request, config) => axios.post(API_ENDPOINTS.labelPreview, {...request}, {responseType: "blob", ...config});

const previewQRCode = (id, config) => axios.get(API_ENDPOINTS.qrcodePreview, {
    params: {
        shipment_no: id
    },
    responseType: "blob",
    ...config
});

const createShareLink = (id) => axios.get(API_ENDPOINTS.createShareLink, {
    params: {
        shipment_no: id
    }
});

const previewShareLink = (request) => axios.post(API_ENDPOINTS.previewShareLink, {...request}, {responseType: "blob"});

const initExportShipment = (request) => axios.get(API_ENDPOINTS.initExportShipment, {
    params: {
        ...request
    }
});

const initExportShipmentBillingDetail = (request) => axios.post(API_ENDPOINTS.initExportShipmentBillingDetail, {
    ...request
});

// ----------------------------------------------------------------------

const {
    useGetShipmentListQuery,
} = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getShipmentList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: ["ShipmentList"],
            query: (request) => `${API_ENDPOINTS.getShipment}${setURLParams(request)}`,
            transformResponse: ({data}, meta, arg) => data
        }),
    }),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    getShipmentDetail as getShipmentDetailAPI,
    getShipmentDetailByTracking as getShipmentDetailByTrackingAPI,
    getShipmentOperateHistory as getShipmentOperateHistoryAPI,
    //
    getRate as getRateAPI,
    getInsuranceRate as getInsuranceRateAPI,
    //
    buyLabel as buyLabelShipmentAPI,
    voidLabel as voidLabelAPI,
    downloadLabel as downloadLabelAPI,
    //
    checkCanPrint as checkCanPrintAPI,
    //
    previewLabel as previewLabelAPI,
    previewQRCode as previewQRCodeAPI,
    //
    createShareLink as createShareLinkAPI,
    previewShareLink as previewShareLinkAPI,
    //
    initExportShipment as initExportShipmentAPI,
    initExportShipmentBillingDetail as initExportShipmentBillingDetailAPI,
    //
    useGetShipmentListQuery,

};
